import axios from "axios";
import { getAuthToken } from "./cookieUtils";

const axiosInstance = axios.create({
  baseURL: `${window.SERVER_PORT.url}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach auth token from localStorage/cookie on every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
